import * as React from "react";
import { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import debounce from "lodash/debounce";
import TextWidgetConfig from "views/logic/widgets/TextWidgetConfig";
import MDBaseEditor from "components/common/MarkdownEditor/BaseEditor";
import Preview from "components/common/MarkdownEditor/Preview";
import FullSizeContainer from "views/components/aggregationbuilder/FullSizeContainer";
const EditorContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
`;
const Item = styled.div`
  flex: 1;
  height: 100%;
`;
const TextWidgetEdit = ({ config, onChange }) => {
  var _a;
  const [text, setText] = useState((_a = config == null ? void 0 : config.text) != null ? _a : "");
  const _onChange = useMemo(
    () => debounce((newText) => onChange(new TextWidgetConfig(newText)), 200),
    [onChange]
  );
  useEffect(() => {
    _onChange(text);
  }, [_onChange, text]);
  return /* @__PURE__ */ React.createElement(FullSizeContainer, null, ({ height }) => /* @__PURE__ */ React.createElement(EditorContainer, null, /* @__PURE__ */ React.createElement(Item, null, /* @__PURE__ */ React.createElement(
    MDBaseEditor,
    {
      key: `markdown-editor-${height}`,
      autoFocus: true,
      onChange: setText,
      value: text,
      height: height - 8
    }
  )), /* @__PURE__ */ React.createElement(Item, null, /* @__PURE__ */ React.createElement(Preview, { value: text, height: height - 8, show: true }))));
};
export default TextWidgetEdit;
